import { RouteItem } from '@eastcoal/router/types/route'

export const chemicalZoneRoute: RouteItem = {
  title: '化工专区',
  path: '/chemical',
  Component: () => import('./index')
}
